import { render, staticRenderFns } from "./ReviewsScheduled.vue?vue&type=template&id=0cc8c064&scoped=true"
import script from "./ReviewsScheduled.vue?vue&type=script&lang=js"
export * from "./ReviewsScheduled.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cc8c064",
  null
  
)

export default component.exports